import { useEffect, useMemo } from "react";

export const useIsAllSaved = (stateSample, setProcessingId, idMuestra) => {
  const allSaved = useMemo(() => {
    if (!stateSample) return false;
    const isSaveValues = Object.values(stateSample).map(
      (item: any) => item.isSave
    );
    return isSaveValues.every((isSave) => isSave === true);
  }, [stateSample]);

  useEffect(() => {
    if (allSaved) {
      setProcessingId(Number(idMuestra));
    }
  }, [allSaved, idMuestra, setProcessingId]);

  return allSaved;
};
